import axios from "axios";
import moment from "moment/moment";

export default {
    data() {
        return {
            moment,
            menuData: [],
            dynamicMenu: [],
            waId: ""
        }
    },
    created() {
        this.waId = this.$route.params.waId
        // this.$swal(this.waId);
    },
    methods: {
        begin_loading() {
            const image = document.getElementById('loadingImage');
            image.style.display = 'block';
            const element = document.getElementById('app');
            element.style.opacity = 0.8;
            element.style.pointerEvents = 'none';
            // this.$swal('Hello Vue world!!!');
        },
        end_loading() {
            const image = document.getElementById('loadingImage');
            image.style.display = 'none';
            const element = document.getElementById('app');
            element.style.opacity = 1;
            element.style.pointerEvents = 'inherit';
        },
        async axiosRequest(templateURL, data) {
            this.begin_loading()
            const NMPUSER = JSON.parse(localStorage.getItem('NMPUSER'))
            if (!(localStorage.getItem('NMPUSER') && NMPUSER && Object.prototype.hasOwnProperty.call(NMPUSER, "token") && NMPUSER.token && NMPUSER.token == this.waId  && NMPUSER.token != "")) {
                this.$router.push('/');
                return false;
            }
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': NMPUSER.token,
                }
            }
            return await axios.post(templateURL,
                data, // the data to post
                config).then((response) => {
                this.end_loading();
                return response;
            }).catch((error) => {
                this.end_loading();
                return error.response;
            });
        },
        sweetAlert(icon, title, desc, varient) {
            this.$swal({
                title: title,
                html: desc,
                icon: icon,
                customClass: {
                    confirmButton: 'btn ' + varient,
                },
                buttonsStyling: false,
            })
        },
        sweetAlertConfirm(title, text, icon, confirmButtonText) {
            this.$swal({
                title: title,
                text: text,
                icon: icon,
                showCancelButton: true,
                confirmButtonText: confirmButtonText,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(async result => {
                return result

            })
        }
    },
}
